import { Injectable, TemplateRef, ViewChild, ElementRef, Renderer2, Directive } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse,HttpClient } from '@angular/common/http';
import { Observable,throwError,of } from 'rxjs';
import { mergeMap,retry, catchError,tap,map } from 'rxjs/operators';
import 'rxjs/add/operator/do';
//import { environment } from 'path to environment/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { AppService } from '../app.service';
import { SignImageService} from '../services/sign-image.service';
import { ConstantConfigService } from '../services/constant-config.service';
import { VersionCheckService } from '../services/version-check.service';
import {EncrDecrServiceService} from '../services/encr-decr-service.service';
import { Router, ActivatedRoute,NavigationExtras } from '@angular/router';
import { JwtHelperService } from "@auth0/angular-jwt";
import { CookieService } from 'ngx-cookie-service';
import { AuthenticationService } from '../services';
import { GeneralService } from '../services/general.service';
import { ScreensizeService } from './screensize.service';

const helper = new JwtHelperService();
@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  _baseURL : string;
  newrequesturl :string;
  _accessToken;
  _currentHash:string;
  decodedToken: any = {};
  _AuthModeCookieEncryptionKey;

  @ViewChild('errorfoundsite', { static: true }) errorfoundsite: ElementRef;
  token = "";
  _CookieExpireTokenTime;
  _guestToken;
  intervalid;
  //dataStream: BehaviorSubject<any> = new BehaviorSubject('Arvind Ng 7');

  //dataStream = new BehaviorSubject('Test Arvind');
  //currentMessage = this.messageSource.asObservable();
  cookieDomain;
  constructor(public signService: SignImageService,public service: AppService,private router: Router,private httpc: HttpClient,private auth: AuthenticationService,public versioncheckService: VersionCheckService, private cookieService: CookieService,private EncrDecr: EncrDecrServiceService,private generalService : GeneralService,  private screenSizeService: ScreensizeService
    ) {
      this._baseURL = ConstantConfigService.baseURL;
      this._accessToken = ConstantConfigService.accessToken;
      //this.signService.modalRefer = this.errorfoundsite;
      this._currentHash = versioncheckService.currentHash;
      this._CookieExpireTokenTime = ConstantConfigService.CookieExpireTokenTime;
      this._guestToken = ConstantConfigService.guestToken;
      this.cookieDomain = ConstantConfigService.cookieDomain;
  }

  private messageSource = new BehaviorSubject('none');
  dataStream = this.messageSource.asObservable();

  changeMessage(message:string) {
    //console.log(message);
    this.messageSource.next(message);
  }

  // dataStream$(): Observable<any> {
  //   return this.dataStream().asObservable();
  // }

  key:string;
  str:string;
  rc4(key, str) {
    var s = [], j = 0, x, res = '';
    for (var i = 0; i < 256; i++) {
      s[i] = i;
    }
    for (i = 0; i < 256; i++) {
      j = (j + s[i] + key.charCodeAt(i % key.length)) % 256;
      x = s[i];
      s[i] = s[j];
      s[j] = x;
    }
    i = 0;
    j = 0;
    for (var y = 0; y < str.length; y++) {
      i = (i + 1) % 256;
      j = (j + s[i]) % 256;
      x = s[i];
      s[i] = s[j];
      s[j] = x;
      res += String.fromCharCode(str.charCodeAt(y) ^ s[(s[i] + s[j]) % 256]);
    }
    return res;
  }


  getEncryptionKey(){
    return this.httpc.get(this._baseURL+"/getkey");
  }

  closeModal() {
    this.signService.closeModal();
  }

  includeAppVersion(request) {
     return request.clone({ headers: request.headers.set('app-version', this._currentHash) });
  }


  encryptData(arraydata, encryptkey) {
    let newdata = [];
    for (let key in arraydata) {
      let numberelement = arraydata[key];
      if ((typeof numberelement != 'undefined' && (typeof numberelement != 'string' && typeof numberelement != 'object' && numberelement.toString().length >= 1)) || (key == 'password'))   { //(key != 'angular')

        numberelement = numberelement.toString();
        var s = [], j = 0, x, res = '';
        for (var i = 0; i < 256; i++) {
          s[i] = i;
        }
        for (i = 0; i < 256; i++) {
          j = (j + s[i] + encryptkey.charCodeAt(i % encryptkey.length)) % 256;
          x = s[i];
          s[i] = s[j];
          s[j] = x;
        }
        //console.log(s);
        i = 0;
        j = 0;
        for (var y = 0; y < numberelement.length; y++) {
          i = (i + 1) % 256;
          j = (j + s[i]) % 256;
          x = s[i];
          s[i] = s[j];
          s[j] = x;
          res += String.fromCharCode(numberelement.charCodeAt(y) ^ s[(s[i] + s[j]) % 256]);
        }
        //console.log(res);
        var variableReturn = btoa(res);
        var variableReturn1 = variableReturn.replace(/\//g, '$$');
        newdata[key] = 'portal' + variableReturn1;
      } else {
        newdata[key] = numberelement;
      }
    }
    return newdata;
  }

  private encryptionKey: string | null = null;
  private encryptionKeyFetchedAt: number | null = null;
  private encryptionKeyTTL = 30000; // 30 seconds 

  private getEncryptionKeyCached(): Observable<string> {
    const now = new Date().getTime();
    if (
      this.encryptionKey &&
      this.encryptionKeyFetchedAt &&
      now - this.encryptionKeyFetchedAt < this.encryptionKeyTTL
    ) {
      return of(this.encryptionKey);
    }

    return this.getEncryptionKey().pipe(
      map((response) => {
        console.log('response is ',response);
        this.encryptionKey = response['data'];
        this.encryptionKeyFetchedAt = now;
        return this.encryptionKey;
      })
    );
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    var fullRoute = this.router.url;
    //console.log('request',request);
    //console.log(this._baseURL);

    if(request!=null && request.url!=null && request.url!=''){
      try{

          if (typeof request.body != 'undefined'  ) {
            let newData = this.encryptData(request.body, 'base64:ijE');
            for (let key in request.body) {
              request.body[key] = newData[key];
            }
          }

          var numberChecked;
          var requestparams = request.url.split('/');
          //console.log('requestparams',requestparams);

          var numbersIndex = [];
          if(requestparams.length > 4){
            for(var i=0;i<requestparams.length;i++){
              var isnumber = /^\d+$/.test(requestparams[i]);
              if(isnumber=== false){
                //request = this.setheaders(request);
              }else{
                var numbers = requestparams[i];
                //console.log('i'+i);
                let index = i;
                numbersIndex.push(i);
              }
            }
          }

          //console.log('numbersIndex',numbersIndex);

          if(requestparams.length > 4){
            for(var i=0;i<requestparams.length;i++){
              var isnumber = /^\d+$/.test(requestparams[i]);
              if(isnumber=== false){

              } else {
                var numbers = requestparams[i];
                //console.log('i'+i);
                let index = i;
                return this.getEncryptionKeyCached().pipe(mergeMap(encryptkey  => {
                    //console.log('response',response); // ==> does work great. I am getting data right
                      //var encryptkey = encryptkey;

                      //function to encrypt each request parameter
                      numbersIndex.forEach(function (val) {
                        //console.log('requestelementis '+requestparams[val]+' encryptkey '+encryptkey);
                        var numberelement = requestparams[val];
                        var s = [], j = 0, x, res = '';
                        for (var i = 0; i < 256; i++) {
                          s[i] = i;
                        }
                        for (i = 0; i < 256; i++) {
                          j = (j + s[i] + encryptkey.charCodeAt(i % encryptkey.length)) % 256;
                          x = s[i];
                          s[i] = s[j];
                          s[j] = x;
                        }
                        i = 0;
                        j = 0;
                        for (var y = 0; y < numberelement.length; y++) {
                          i = (i + 1) % 256;
                          j = (j + s[i]) % 256;
                          x = s[i];
                          s[i] = s[j];
                          s[j] = x;
                          res += String.fromCharCode(numberelement.charCodeAt(y) ^ s[(s[i] + s[j]) % 256]);
                        }
                        var variableReturn = btoa(res);
                        var variableReturn1 = variableReturn.replace(/\//g,'$$');
                        requestparams[val]='portal'+variableReturn1;
                      });

                      console.log('after conversion requ par',requestparams)

                      this.newrequesturl = requestparams.join('/');
                      console.log('newrequesturl ',this.newrequesturl);
                      var fullRoute = this.router.url;

                      const authToken: any = localStorage.getItem(this._accessToken);
                      if (typeof authToken !='undefined' && authToken !=null && authToken != '') {
                          request = request.clone({
                            url: this.newrequesturl,
                            headers: request.headers.set('Authorization', 'Bearer ' + authToken)
                          });
                      }

                      //const gToken = this.cookieService.get(ConstantConfigService.guestToken);
                      const gToken: any = localStorage.getItem(this._guestToken);
                      //console.log('inside interceptor g token is inner api is ',gToken);
                      //console.log(request.url);
                      if (gToken != '' && gToken != null && typeof gToken !='undefined' && request.url != this._baseURL + "/getkey") {
                        let obj = JSON.parse(gToken);
                        let guesttoken = obj.token;
                        request = request.clone({
                          url: this.newrequesturl,
                          headers: request.headers.set('g-token', guesttoken)
                        });
                      }

                      if (this._currentHash) {
                        request = request.clone({ headers: request.headers.set('app-version', this._currentHash) });
                      }
		      
		      const screenSize = this.screenSizeService.getScreenSize();
                      console.log('screenSize',screenSize);
                      request = request.clone({
                        headers: request.headers
                            .set('x-screen-width', screenSize.width.toString())
                            .set('x-screen-height', screenSize.height.toString())
                      });

                      console.log('request',request);
                      return next.handle(request).do((event: HttpEvent<any>) => {
                        if (event instanceof HttpResponse) {
                          console.log("Service Response thr Interceptor");
                          if(event.body.g_token){
                            this.token = event.body.g_token;

                            let tokenobject = {token: this.token, timestamp: new Date().getTime()};
                            localStorage.removeItem(this._guestToken);
                            localStorage.setItem(this._guestToken, JSON.stringify(tokenobject));

                            this.cookieService.delete(this._guestToken);
                            this.cookieService.set(this._guestToken, JSON.stringify(tokenobject), this._CookieExpireTokenTime);
                          }
                        }
                      }, (err: any) => {
                        console.log('comes inside error why');
                        console.log(err);
                        //console.log(err.error.message);
                        //console.log("=========================err.status==============================Request1");
                        if (err instanceof HttpErrorResponse) {
                          //const myToken = localStorage.getItem(this._accessToken);
                          const myToken = this.cookieService.get(this._accessToken);
                          if(typeof myToken!="undefined" && myToken!="" && myToken!=null && myToken!="undefined"){
                          const decodedToken = helper.decodeToken(myToken);
                            var current_time = new Date().getTime() / 1000;
                            if (current_time > decodedToken.exp) {
                              this.cookieService.delete(this._accessToken);
                              localStorage.removeItem(this._accessToken);
                            }
                          }else if(typeof myToken=="undefined"){
                            this.cookieService.delete(this._accessToken);
                            localStorage.removeItem(this._accessToken);
                          }
                          if(err.error.message=="Token has expired"){
                              //this.messageSource.next(err.error.error);
                              var fullRoute = this.router.url;
                              if (fullRoute.indexOf('free-flow') > -1 || fullRoute.indexOf('edit-document') > -1 || fullRoute.indexOf('signature') > -1 || fullRoute.indexOf('doc-comments') > -1 || fullRoute.indexOf('upload-doc') > -1 || fullRoute.indexOf('cdk-drag-drop') > -1 || fullRoute.indexOf('download') > -1 || fullRoute.indexOf('preview-document') > -1){
                                  //console.log("I am in header");
                                  this.cookieService.delete(ConstantConfigService.accessToken);
                                  localStorage.removeItem(ConstantConfigService.accessToken);
                              }else{
                                setTimeout(() => {
                                    this.service.geterrorMessage('Session expire!. Please login again');
                                    if (document.getElementsByClassName("modal").length === 0) {

                                    } else {
                                      // do something when a modal is open
                                      this.signService.closeModal();
                                    }
                                    location.href = '/login';
                                }, 1000);
                              }
                              //location.href = '/login';
                          }else{
                            //console.log("=========================err.status==============================Request3");
                            if (err.status === 401 || err.status === 403 || err.status === 500 || err.status === 422) {

                              if (err.status === 422){

                                let errormessages = err.error.message;
                                const errors = [];

                                for (const property in errormessages) {
                                  console.log('property is ',property);
                                  if (errormessages.hasOwnProperty(property)) {
                                    // 6 - Extract it's array of errors
                                    const propertyErrors: Array<string> = errormessages[property];
                                    // 7 - Push all errors in the array to the errors array
                                    propertyErrors.forEach(error => errors.push(error));
                                  }

                                }

                                if(errors.length > 0){
                                  let errorresp = '';
                                  for(let j=0; j<errors.length; j++){
                                    if(j>0){
                                      errorresp += ', ';
                                    }
                                    errorresp += errors[j];
                                  }

                                  this.generalService.showToasterErrorMessage(errorresp);
                                }
                              }
                              if (err.status === 500){
                                this.signService.showModalError();
                              }
                              if (err.status === 401){
                                if (err.error.message == 'The token could not be parsed from the request') {

                                  this.cookieService.delete(this._accessToken);
                                  localStorage.removeItem(this._accessToken);

                                  setTimeout(() => {
                                    this.service.geterrorMessage('Unauthorized access, Invalid Token');
                                    location.href = '/login';
                                  }, 1000);

                                }
                                if (err.error.error == 'Invalid Token') {
                                  this.cookieService.delete(this._guestToken);
                                  localStorage.removeItem(this._guestToken);
                                  this.intervalid = this.versioncheckService.refreshGuestToken();
                                  console.log('intervalid id is ',this.intervalid);
                                  setTimeout(() => {
                                    this.service.geterrorMessage('Invalid Token');
                                    //location.href = '/login';
                                  }, 1000);

                                }
                                if(typeof err.error.error != 'undefined' && err.error.error == 'App not updated, Please refresh the page and try again'){

                                  let hash_changes_load: any = this.cookieService.get('hash_changes_load');
                                  // Check cookies set for reload
                                  let pageReload = 0;
                                  if(typeof hash_changes_load!="undefined" && typeof hash_changes_load!=null && hash_changes_load!=0 && hash_changes_load==1){
                                    pageReload = 1;
                                  }else{
                                    pageReload = 0;
                                  }
                                  if(pageReload==0){
                                    this.signService.showModalError401();
                                  }
                                }
                              }
                              return throwError(err.error.message);

                            }else if(err.status === 413 || (err.status === 0 && err?.statusText == 'Unknown Error')){
                              var fullRoute = this.router.url;
                              if (fullRoute.indexOf('share-template') > -1 || fullRoute.indexOf('create-template') > -1 || fullRoute.indexOf('send-request') > -1){
                                this.generalService.showToasterErrorMessage('The file is too large. Please upload a smaller file.');
                              }
                              //this.generalService.showToasterErrorMessage('The file is too large. Please upload a smaller file.');
                            }
                          }
                        }
                      });
                    })
                );

              }
            }
        }
      } catch(err){
      }
    }

    //Get Auth Token from Service which we want to pass thr service call
    //const authToken: any = 'Bearer ${sessionStorage.getItem("jwtToken")}'
    const authToken: any = localStorage.getItem(ConstantConfigService.accessToken);
    const apiToken: any = localStorage.getItem(ConstantConfigService.apiToken);
    //const securityToken: any = localStorage.getItem(ConstantConfigService.securityToken);
    const securityToken: any = this.cookieService.get(ConstantConfigService.securityToken);

    if (authToken && authToken!="undefined") {
        request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + authToken) });
    }

    const gToken: any = localStorage.getItem(ConstantConfigService.guestToken);
    if (gToken != '' && gToken != null && typeof gToken !='undefined' && request.url != this._baseURL + "/getkey") {
      let obj = JSON.parse(gToken);
      let guesttoken = obj.token;
      request = request.clone({ headers: request.headers.set('g-token', guesttoken) });
    }

    const screenSize = this.screenSizeService.getScreenSize();
    console.log('screenSize',screenSize);
    request = request.clone({
      headers: request.headers
          .set('x-screen-width', screenSize.width.toString())
          .set('x-screen-height', screenSize.height.toString())
    });

    /*if (apiToken) {
        request = request.clone({ headers: request.headers.set('apitoken', apiToken) });
    }

    if (securityToken) {
      request = request.clone({ headers: request.headers.set('securityToken', securityToken) });
    }

    */
    if (this._currentHash) {
      request = request.clone({ headers: request.headers.set('app-version', this._currentHash) });
    }

    if (!request.headers.has('Content-Type')) {
        //request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
    }

    //request = request.clone({ headers: request.headers.set('Access-Control-Allow-Origin', '*') });

    //request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

    // Clone the service request and alter original headers with auth token.
    // const authReq = req.clone({
    //   headers: req.headers.set('Content-Type', 'application/json').set('Authorization', authToken)
    // });

    // authReq = req.clone({ setHeaders: { 'Authorization': authToken, 'Content-Type': 'application/json'} });

    // Send cloned request with header to the next handler.
    return next.handle(request).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        //console.log("Service Response thr Interceptor");
        if(event.body.g_token){
          this.token = event.body.g_token;

          let tokenobject = {token: this.token, timestamp: new Date().getTime()};

          localStorage.removeItem(this._guestToken);
          localStorage.setItem(this._guestToken, JSON.stringify(tokenobject));

          this.cookieService.delete(this._guestToken);
          this.cookieService.set(this._guestToken, JSON.stringify(tokenobject), this._CookieExpireTokenTime);


          console.log('klklkl');
        }
      }
    }, (err: any) => {
      //console.log(err.error.message);
      //console.log("=========================err.status==============================Request1");
      if (err instanceof HttpErrorResponse) {

        const myToken = localStorage.getItem(this._accessToken);
        if(typeof myToken!="undefined" && myToken!="" && myToken!=null && myToken!="undefined"){
         const decodedToken = helper.decodeToken(myToken);
          var current_time = new Date().getTime() / 1000;
          if (current_time > decodedToken.exp) {
            localStorage.removeItem(this._accessToken);
            this.cookieService.delete(this._accessToken);

          }
        }else if(myToken=="undefined"){
          localStorage.removeItem(this._accessToken);
          this.cookieService.delete(this._accessToken);
        }

        if(err.error.message=="Token has expired"){
            //this.messageSource.next(err.error.error);
            var fullRoute = this.router.url;
            if (fullRoute.indexOf('free-flow') > -1 || fullRoute.indexOf('viewdoc') > -1 || fullRoute.indexOf('edit-document') > -1 || fullRoute.indexOf('signature') > -1 || fullRoute.indexOf('sign') > -1 || fullRoute.indexOf('doc-comments') > -1 || fullRoute.indexOf('upload-doc') > -1 || fullRoute.indexOf('cdk-drag-drop') > -1 || fullRoute.indexOf('download') > -1 || fullRoute.indexOf('preview-document') > -1 || fullRoute.indexOf('prefill-request') > -1 || fullRoute.indexOf('approve-hubspot-properties-updation') > -1){
                //console.log("I am in header");
                localStorage.removeItem(ConstantConfigService.accessToken);
                this.cookieService.delete(this._accessToken);
            }else{
              setTimeout(() => {
                  this.service.geterrorMessage('Session expire!. Please login again');
                  if (document.getElementsByClassName("modal").length === 0) {

                  } else {
                    // do something when a modal is open
                    this.signService.closeModal();
                  }

                  if(fullRoute.indexOf('dealhub') > -1){
                    this.cookieService.delete(this._accessToken);
                    localStorage.removeItem(this._accessToken);
                    //this.generalService.showToasterErrorMessage('Sorry, you have been loogged out');
                    localStorage.setItem('dealhub_current_url', btoa(fullRoute));
                    localStorage.setItem('session_expired', '1');
                  }
                  location.href = '/login';
               }, 1000);
            }
        } else {
          //console.log("=========================err.status==============================Request3");
          if (err.status === 401 || err.status === 403 || err.status === 500 || err.status === 422 || err.status === 435) {

              console.log("===========");
              console.log(err.error.message);
              console.log("Come Here =================",err.status);
            if (err.status === 422){

              let errormessages = err.error.message;
              const errors = [];

              for (const property in errormessages) {
                console.log('property is ',property);
                if (errormessages.hasOwnProperty(property)) {
                  // 6 - Extract it's array of errors
                  const propertyErrors: Array<string> = errormessages[property];
                  // 7 - Push all errors in the array to the errors array
                  propertyErrors.forEach(error => errors.push(error));
                }

              }

              if(errors.length > 0){
                let errorresp = '';
                for(let j=0; j<errors.length; j++){
                  if(j>0){
                    errorresp += ', ';
                  }
                  errorresp += errors[j];
                }

                this.generalService.showToasterErrorMessage(errorresp);
              }
            }

            // window.alert(err.error.message);
            if (err.status === 500){
              this.signService.showModalError();
            }
            if (err.status === 401){
              //console.log("1111111111111111111Come Here =================",err.error);
              if (typeof err.error.message != 'undefined' && err.error.message == 'Invalid Token' || err.error.error == 'Invalid Token' || err.error.message == 'Unauthorized' || err.error.error == 'Unauthorized') {
                this.cookieService.delete(this._guestToken);
                localStorage.removeItem(this._guestToken);
                this.cookieService.delete(this._accessToken,"/",this.cookieDomain,true,"None")
                localStorage.removeItem(this._accessToken);
		            this.intervalid = this.versioncheckService.refreshGuestToken();
                //console.log('intervalid id is ',this.intervalid);
                setTimeout(() => {
                  this.service.geterrorMessage('Invalid Token');
                  if(err.error.message == 'Unauthorized' || err.error.error == 'Unauthorized'){
                    this.cookieService.delete(this._accessToken);
                    localStorage.removeItem(this._accessToken);
		    localStorage.setItem('dealhub_current_url', btoa(fullRoute));
                    localStorage.setItem('session_expired', '1');
                    location.href = '/login';
                  }
                }, 1000);

              }else if (typeof err.error.message != 'undefined' && err.error.message == 'The token could not be parsed from the request' || err.error.error == 'The token could not be parsed from the request') {
                //this.generalService.showToasterErrorMessage("Session expired! Please login and try again.");
                this.cookieService.delete(this._accessToken);
                localStorage.removeItem(this._accessToken);
                //setTimeout(() => {
                  //this.generalService.showToasterErrorMessage("Session expired! Please login and try again.");
		   localStorage.setItem('dealhub_current_url', btoa(fullRoute));
                  location.href = '/dealhubsession/token';
                //}, 1000);
              }else if(typeof err.error.message != 'undefined' && err.error.message.indexOf("payload is invalid") > 0) {
                this.cookieService.delete(this._guestToken);
                localStorage.removeItem(this._guestToken);
		            this.intervalid = this.versioncheckService.refreshGuestToken();
                //this.generalService.showToasterErrorMessage("Session expired! Please login and try again."); //ankit comment
                setTimeout(() => {
                  this.cookieService.delete(this._accessToken);
                  localStorage.removeItem(this._accessToken);
		  localStorage.setItem('dealhub_current_url', btoa(fullRoute));
                  localStorage.setItem('session_expired', '1');
                  location.href = '/login';
                }, 1000);
              }else if(typeof err.error.error != 'undefined' && err.error.error == 'App not updated, Please refresh the page and try again'){
                let hash_changes_load: any = this.cookieService.get('hash_changes_load');
                // Check cookies set for reload
                let pageReload = 0;
                if(typeof hash_changes_load!="undefined" && typeof hash_changes_load!=null && hash_changes_load!=0 && hash_changes_load==1){
                  pageReload = 1;
                }else{
                  pageReload = 0;
                }
                if(pageReload==0){
                  this.signService.showModalError401();
                }
              }
            }
            return throwError(err.error.message);

          }else if(err.status === 413 || (err.status === 0 && err?.statusText == 'Unknown Error')){
            var fullRoute = this.router.url;
            if (fullRoute.indexOf('share-template') > -1 || fullRoute.indexOf('create-template') > -1 || fullRoute.indexOf('send-request') > -1){
              this.generalService.showToasterErrorMessage('The file is too large. Please upload a smaller file.');
            }
          }
        }
      }
    });

  }
}
